import * as React from "react";

const Invoices2: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 30" fill="currentColor">
            <switch>
                <g>
                    <path d="M15.25.32H3.45C1.72.32.32 1.72.32 3.45v23.12c0 1.73 1.4 3.13 3.13 3.13h16.1c1.72 0 3.12-1.4 3.12-3.12V7.71L15.25.32zm4.3 27.45H3.45c-.67 0-1.21-.55-1.21-1.21V3.44c0-.66.54-1.21 1.21-1.21l11.08-.01v4.09c0 1.2.97 2.17 2.17 2.17l4.01-.01.04 18.09c.01.67-.53 1.21-1.2 1.21z" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.53 16.83c.4 0 .72.32.72.72s-.32.72-.72.72-.72-.32-.72-.72.32-.72.72-.72M16.47 17.05H9.14c-.4 0-.72.21-.72.48 0 .26.32.48.72.48h7.33c.4 0 .71-.21.71-.48.01-.26-.31-.48-.71-.48M6.53 19.83c.4 0 .72.32.72.72s-.32.72-.72.72-.72-.32-.72-.72.32-.72.72-.72M14.47 20.05H9.14c-.4 0-.72.21-.72.48 0 .26.32.48.72.48h5.33c.4 0 .71-.21.71-.48.01-.26-.31-.48-.71-.48M6.53 22.83c.4 0 .72.32.72.72s-.32.72-.72.72-.72-.32-.72-.72.32-.72.72-.72M12.47 23.05H9.14c-.4 0-.72.21-.72.48 0 .26.32.48.72.48h3.33c.4 0 .71-.21.71-.48.01-.26-.31-.48-.71-.48"
                    />
                    <path d="M10.37 10.28c-.37-.64-1.14-.89-1.94-1.09V7.11c.47.1.95.29 1.38.57l.56-.83c-.6-.4-1.27-.65-1.94-.75v-.78h-1v.73h-.01c-.75.09-1.74.5-2.04 1.37-.23.65-.05 1.31.48 1.81.41.38.98.58 1.57.74v2.09c-.6-.13-1.22-.4-1.65-.69l-.56.83c.56.38 1.4.74 2.21.88v.79h1v-.74c.47-.05 1.7-.2 2.04-1.4.17-.56.14-1.05-.1-1.45zM6.54 8.5c-.24-.23-.31-.48-.22-.75.13-.36.64-.61 1.11-.69v1.86c-.36-.1-.68-.23-.89-.42zm2.98 2.97c-.11.38-.43.56-1.08.66v-1.9c.49.14.92.3 1.07.56.03.05.14.23.01.68z" />
                </g>
            </switch>
        </svg>
    );
};

export default React.memo(Invoices2);
